/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetNewobjectInfoModel,
  IGetNewobjectInfoRequest,
  IMappers,
  IGetNewobjectInfoResponse,
  IGetNewobjectInfoResponseNotFoundError,
  IGetNewobjectInfoResponseError,
  TGetNewobjectInfoResponse,
} from './types';

const defaultConfig: TGetNewobjectInfoModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400, 404],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-newobject-info/',
  hostType: 'api',
} as TGetNewobjectInfoModel;

function createGetNewobjectInfoModel(parameters: IGetNewobjectInfoRequest): TGetNewobjectInfoModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewobjectInfoOptions<TResponse200, TResponse400, TResponse404> {
  httpApi: IHttpApi;
  parameters: IGetNewobjectInfoRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400, TResponse404>;
}

async function fetchGetNewobjectInfo<TResponse200, TResponse400, TResponse404>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewobjectInfoOptions<TResponse200, TResponse400, TResponse404>): Promise<
  TResponse200 | TResponse400 | TResponse404 | TGetNewobjectInfoResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetNewobjectInfoModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewobjectInfoResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewobjectInfoResponseError);
    }

    if (statusCode === 404) {
      return mappers[404](response as IGetNewobjectInfoResponseNotFoundError);
    }
  }

  return { response, statusCode } as TGetNewobjectInfoResponse;
}

export { defaultConfig, createGetNewobjectInfoModel, fetchGetNewobjectInfo };
